import { Tooltip } from "antd";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { ACTION_BTN_HOVER_CLR } from "@/Constants/common";
import {
  fetchUnfilledContracts,
  setUnfilledContractsLoading,
  updatePagination,
  toggleAppliedCandidateForContractModal,
  updateSelectedCandidatesForProposeCandidate,
} from "@/reducers/clientunfilledcontracts";
import { toastMessageText } from "@/utilities/CommonText";
import { showCommonToast } from "@/utilities/utils";

import ActionIcons from "../../ActionIcons";
import NoAccessButtonWrapper from "../../UserRoleAccess/NoAccessButtonWrapper";

const Actions = () => {
  const dispatch = useDispatch();
  const {
    selectedContracts,
    unfilledContracts,
    pagination,
    isSelectedAll,
    filters,
  } = useSelector((state) => state.clientUnfilledContracts);
  const { clientUserAllPermissions, isPremiumAccount } = useSelector(
    (state) => state.session,
  );
  const { user } = useSelector((state) => state.clientProfile);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const handleReloadTable = () => {
    dispatch(
      updatePagination({
        ...pagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(fetchCandidateTypes());
    dispatch(setUnfilledContractsLoading(true));
    dispatch(fetchUnfilledContracts(filters));
  };

  // const handleDeleteConfirm = () => {
  //   dispatch(
  //     deleteUnfilledContractdata({
  //       contract_ids: selectedContracts.join(","),
  //       callback: () => handleReloadTable(),
  //       loading: deleteLoading,
  //       setLoading: setDeleteLoading,
  //       isSelectedAll: isSelectedAll,
  //       ignoreIds: isSelectedAll
  //         ? unfilledContracts
  //             .filter((ele) => !selectedContracts.includes(ele.contract_id))
  //             .map((ele) => ele.contract_id)
  //             .join(",")
  //         : "",
  //     }),
  //   );
  // };

  const handleClick = (e) => {
    if (selectedContracts.length > 0) {
      if (selectedContracts.length == 1) {
        dispatch(updateSelectedCandidatesForProposeCandidate([]));
        dispatch(toggleAppliedCandidateForContractModal(true));
      } else {
        showCommonToast(toastMessageText?.onlyOneUnfilledContractSelected, {
          id: "app-locum-candidates-selected",
        });
      }
    } else {
      showCommonToast(toastMessageText?.onlyOneUnfilledContractSelected, {
        id: "locum-contract-shifts",
      });
    }
  };

  return (
    <div className="Actions_Wrapper tour-unfilled-actions">
      <div className="flex h-[40px] cursor-pointer overflow-hidden rounded-lg bg-grey [&>*:last-child]:border-r-0 [&>*]:grid [&>*]:w-[56px] [&>*]:min-w-[56px] [&>*]:place-items-center [&>*]:border-0 [&>*]:border-r [&>*]:border-r-[#E5E6E9] [&>*]:text-txtColor">
        {/* <ExportButton
          page={SELECT_EXPORT_PAGES.UNFILLED}
          // exportUrl={routingConstants.exportUnfilled}
          exportFunction={_exportUnfilledContracts}
          selectedTablesData={selectedContracts}
          ignoreIds={
            isSelectedAll
              ? unfilledContracts
                .filter((ele) => !selectedContracts.includes(ele.contract_id))
                .map((ele) => ele.contract_id)
                .join(",")
              : ""
          }
          isSelectedAll={isSelectedAll}
          extraObj={{
            contract_ids: selectedContracts.join(","),
          }}
          emptyExportMessage={toastMessageText.emptyExportMessageForContract}
        /> */}

        <Tooltip title={"Proposed contract"}>
          <NoAccessButtonWrapper
            _checkPermission={["is_allow_to_proposed_candidates"]}
            _element="span"
          >
            <div
              className={`${ACTION_BTN_HOVER_CLR.green} group`}
              onClick={handleClick}
            >
              <ActionIcons isLoading={false} type="contractPublishToAppLocum" />
            </div>
          </NoAccessButtonWrapper>
        </Tooltip>
      </div>
    </div>
  );
};

export default Actions;
